let API_BASE_URL = '';
let SIGNKEY = '';
let ENSKEY = '';
let IVKEY = '';
switch (import.meta.env.VITE_USER_NODE_ENV) {
  case 'production':
    API_BASE_URL = 'https://gw-pro-external.youhangjh.com';
    SIGNKEY = 'WJxfqrnOZAfL3YBJO8crx5TuKZkzvZCtCI7PPeNPQDGHIC07yY7o34MMJK6B6PN7';
    ENSKEY = 'VdI2yvFx2mJt2ECX';
    IVKEY = 'WK6EdgHihMnpsFJd';
    break;
  case 'test':
    API_BASE_URL = 'https://gw-test-external.youhangjh.com';
    SIGNKEY = '9tisVfmYyrZ3rMOhC6aEOaFwBpdrENu4VFXNzVXZzLy2lu79xTY5c07Vxe5bvXVO';
    ENSKEY = 'YUnDlSCcyvbhQ0bV';
    IVKEY = 'qBOWS5fNSseXLHuZ';
    break;
  default:
    API_BASE_URL = 'https://gw-test-external.youhangjh.com';
    SIGNKEY = '9tisVfmYyrZ3rMOhC6aEOaFwBpdrENu4VFXNzVXZzLy2lu79xTY5c07Vxe5bvXVO';
    ENSKEY = 'YUnDlSCcyvbhQ0bV';
    IVKEY = 'qBOWS5fNSseXLHuZ';
}
export { API_BASE_URL, SIGNKEY, ENSKEY, IVKEY };
